<div class="coro-card-wrapper coro-card-wrapper--mega-card">
  <div class="coro-card-wrapper__inner mega-card">
    <!-- Always show the first 3 cards -->
    @for (block of getMegaCardBlocks().slice(0, maxVisibleCards); track block) {
      <coro-mega-card [card]="block.data" [cardType]="block?.type ?? 'MEGA-CARD'" [block]="block"></coro-mega-card>
    }
  </div>

  <!-- Additional cards with animation -->
  <div class="coro-card-wrapper__inner additional-cards-container" [@slideToggle]="isExpanded ? 'open' : 'closed'">
    @for (block of getMegaCardBlocks().slice(maxVisibleCards); track block) {
      <coro-mega-card [card]="block.data" [cardType]="block?.type ?? 'MEGA-CARD'" [block]="block"></coro-mega-card>
    }
  </div>
  @if (hasMoreCards()) {
    <div class="coro-card-wrapper__toggle-button">
      <button class="coro-btn coro-btn--text" (click)="toggleView()">
        {{ this.isExpanded ? 'View Less' : ('View More' | translate) }}
        <coro-icon iconType="arrow" [position]="this.isExpanded ? 'up' : 'down'"></coro-icon>
      </button>
    </div>
  }
</div>
